import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { Component, inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FileSummaryDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  FileSizeDisplayPipe,
  IsImagePipe,
  LuxonDatePipe,
  SimpleChipComponent,
  StateStatusChipComponent,
} from '@workspace/ng-aura';
import { FilePurposeDisplayPipe } from '@workspace/ng-data-access';
import { FileColumnKey } from './abstract-files-data-table.component';
import { FileDataTableFilterCoreComponent } from './filter/file-data-table-filter.component';

@Component({
  selector: 'core-files-data-table',
  standalone: true,
  templateUrl: './files-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    MatIconModule,
    MatTooltipModule,
    FileDataTableFilterCoreComponent,
    AvatarAuraComponent,
    RouterModule,
    FilePurposeDisplayPipe,
    FileSizeDisplayPipe,
    MatButton,
    IsImagePipe,
    StateStatusChipComponent,
    SimpleChipComponent,
  ],
})
export class FilesDataTableCoreComponent extends BaseDataTableCoreComponent<FileSummaryDto, FileColumnKey> {
  private overlayRef: OverlayRef | null = null;

  overlay = inject(Overlay);
  vcr = inject(ViewContainerRef);

  constructor() {
    super();
  }

  showTooltip(file: FileSummaryDto, event: MouseEvent, tooltipTemplate: TemplateRef<unknown>) {
    this.hideTooltip();

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(event.target as HTMLElement)
      .withPositions([
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
          offsetY: 4,
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
          offsetY: -4,
        },
      ]);

    this.overlayRef = this.overlay.create({ positionStrategy });
    const portal = new TemplatePortal(tooltipTemplate, this.vcr, {
      $implicit: file,
    });
    this.overlayRef.attach(portal);
  }

  hideTooltip() {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = null;
    }
  }
}
